import { Card } from "react-bootstrap";

export default function WhatsAppPreview({
  headerImageUrl,
  params,
  contactName = "Rahul",
  template,
}) {
  const { param2, param3, param4 } = params;
  const bodyTemplate = template?.components?.find(
    (component) => String(component.type || "").toUpperCase() === "BODY"
  );
  const footerTemplate = template?.components?.find(
    (component) => String(component.type || "").toUpperCase() === "FOOTER"
  );
  const buttonTemplate = template?.components?.find(
    (component) => String(component.type || "").toUpperCase() === "BUTTONS"
  );
  const bodyText = String(bodyTemplate?.text || "").trim();
  const bodyLines = bodyText
    ? bodyText.split("\n")
    : [
        `Hello ${contactName},`,
        "Preview will update when a template is selected.",
      ];
  const displayLines = bodyLines.map((line) =>
    line
      .replace("{{1}}", contactName)
      .replace("{{2}}", param2 || "Value 2")
      .replace("{{3}}", param3 || "Value 3")
      .replace("{{4}}", param4 || "Value 4")
      .replace("{{5}}", "")
  );

  return (
    <Card
      className="shadow-sm border-0"
      style={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        borderRadius: "18px",
        background: "#1f1f1f",
        color: "#fff",
      }}
    >
      <div
        style={{
          background: "#f2f2f2",
          padding: "10px",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: "18px",
            overflow: "hidden",
            minHeight: "540px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "12px",
              minHeight: "330px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {headerImageUrl ? (
              <img
                src={headerImageUrl}
                alt="Campaign header"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "300px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  borderRadius: "14px",
                  background:
                    "linear-gradient(135deg, rgba(255,153,0,0.18), rgba(255,196,0,0.16))",
                  display: "grid",
                  placeItems: "center",
                  color: "#7a7a7a",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                }}
              >
                Image preview
              </div>
            )}
          </div>

          <div
            style={{
              background: "#262626",
              padding: "14px 16px 12px",
              color: "#fff",
              fontSize: "0.98rem",
              lineHeight: 1.28,
            }}
          >
            {displayLines.map((line, index) => (
              <div
                key={line}
                style={{
                  marginTop: index === 0 ? 0 : 4,
                  fontWeight: index === 0 ? 700 : 500,
                }}
              >
                {line}
              </div>
            ))}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "12px",
                color: "rgba(255, 255, 255, 0.62)",
                fontSize: "0.88rem",
                fontWeight: 600,
              }}
            >
              <span>{footerTemplate?.text || "conditions applied"}</span>
              <span>3:23 PM</span>
            </div>

            {buttonTemplate?.buttons?.length > 0 && (
              <div
                style={{
                  marginTop: "12px",
                  borderRadius: "12px",
                  background: "rgba(255, 255, 255, 0.12)",
                  padding: "10px 12px",
                  textAlign: "center",
                  fontWeight: 700,
                  color: "#eaeaea",
                }}
              >
                {buttonTemplate.buttons[0]?.text || "Quick Reply"}
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
